module.exports = __webpack_public_path__ + "img/site_46.14fa7d21.png";